var map = {
	"./active-btn.webp": 2527,
	"./angbao-bonus-cny.webp": 2528,
	"./angbao-bonus-dewali.webp": 2529,
	"./angbao-bonus-mooncake.webp": 2530,
	"./angbao-bonus-raya.webp": 2531,
	"./angbao-bonus-thaipusam.webp": 2532,
	"./angbao-bonus.webp": 2533,
	"./anni-lucky-draw.webp": 2534,
	"./cny-angbao-bonus.webp": 2535,
	"./cny-lucky-draw.webp": 2536,
	"./cny-promo.webp": 2537,
	"./dewali-promo.webp": 2538,
	"./dongzhi-angbao-bonus.webp": 2539,
	"./fifa-prediction.webp": 2540,
	"./fifa-qna.webp": 2541,
	"./uefa-predic.webp": 2542,
	"./welcome-cny-bonus.webp": 2543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2526;